var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatbao404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_930_15028)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_930_15028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 360,
    height: 360
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 0H0V360H360V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_930_15028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6597 263.061H132.417V302.279H46.6597V263.061Z",
    fill: "white",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0981 262.016L68.1162 286.854L74.3763 276.658L80.6363 286.854L86.2363 277.737L91.3511 286.07V262.082L68.0981 262.016Z",
    fill: "#FEBA91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3366 135.682L76.1997 127.746",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.924 200.748C120.451 195.082 122.094 184.575 108.492 178.053C94.8896 171.531 86.5921 165.048 82.9663 150.535",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4791 148.43L82.0889 135.831C81.7373 134.524 80.3929 133.75 79.086 134.102L77.3427 134.571C76.0358 134.922 75.2615 136.267 75.6131 137.574L79.0033 150.173C79.3549 151.48 80.6994 152.254 82.0062 151.902L83.7496 151.433C85.0564 151.082 85.8307 149.737 85.4791 148.43Z",
    fill: "#49BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4358 174.313L46.2197 174.307",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6014 170.738H55.5539C54.2006 170.738 53.1035 171.835 53.1035 173.189V174.994C53.1035 176.347 54.2006 177.444 55.5539 177.444H68.6014C69.9547 177.444 71.0518 176.347 71.0518 174.994V173.189C71.0518 171.835 69.9547 170.738 68.6014 170.738Z",
    fill: "#49BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.144 173.776C69.144 173.776 99.3412 172.076 113.45 197.439",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.717 230.643C255.821 230.643 261.581 232.535 261.967 250.773C262.353 269.011 261.545 285.497 277.459 285.286C292.164 285.09 288.897 279.141 295.693 279.403",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.252 272.082H294.259C293.175 272.082 292.297 272.96 292.297 274.044V284.629C292.297 285.713 293.175 286.591 294.259 286.591H311.252C312.335 286.591 313.214 285.713 313.214 284.629V274.044C313.214 272.96 312.335 272.082 311.252 272.082Z",
    fill: "#49BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.022 272.061L306.001 286.615",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.769 275.961H320.969M309.769 281.386H320.969",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.097 108.213C158.84 103.4 127.542 121.483 115.878 151.669C115.878 151.669 115.616 152.519 115.245 153.925C114.944 154.743 114.642 155.554 114.38 156.45C112.586 162.86 111.756 169.501 111.916 176.155C113.553 203.19 136.95 223.759 164.217 222.137C174.84 221.537 184.985 217.518 193.138 210.68C201.292 203.843 207.016 194.553 209.458 184.196C203.942 202.525 183.875 212.961 165.375 207.492C158.125 205.382 151.762 200.962 147.254 194.904C142.747 188.846 140.341 181.481 140.403 173.93C140.455 169.453 141.251 165.015 142.759 160.799C152.862 132.459 184.23 117.597 212.833 127.585C235.071 135.363 250.257 156.342 249.909 179.708C251.717 144.455 226.312 113.558 191.097 108.205",
    fill: "#EE7226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.865 245.702C202.121 250.522 233.42 232.44 245.083 202.254C245.083 202.254 245.346 201.396 245.717 199.99C246.018 199.179 246.319 198.361 246.582 197.472C248.372 191.062 249.202 184.422 249.046 177.768C247.408 150.733 224.012 130.156 196.745 131.785C186.121 132.385 175.975 136.403 167.822 143.241C159.668 150.079 153.945 159.369 151.504 169.727C157.019 151.397 177.087 140.962 195.586 146.423C202.837 148.528 209.202 152.941 213.716 158.993C218.23 165.045 220.646 172.404 220.597 179.954C220.545 184.431 219.749 188.869 218.242 193.085C208.138 221.425 176.77 236.287 148.167 226.299C125.929 218.521 110.743 197.542 111.091 174.176C109.283 209.429 134.688 240.319 169.903 245.671",
    fill: "#E3262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.122 66.3633V73.7898M257.835 70.0765H250.411",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.31 93.5551V100.979M205.021 97.2683H197.597M158.693 57.4746V64.8981M162.403 61.1878H154.979M113.983 117.872V125.295M117.696 121.582H110.27M62.7393 89.1094V96.5359M66.4496 92.8227H59.0261M54.6347 199.183V206.607M58.3449 202.897H50.9215M39.7305 137.74V145.167M43.4438 141.453H36.0173M287.719 159.049V166.476M291.432 162.762H284.008M301.447 97.4763V104.903M305.157 101.19H297.734M328.899 206.504V213.928M332.612 210.215H325.185",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.784 206.212L257.244 175.49H205.03L205.542 176.129H114.245L80.7749 206.851V214.781H114.23V303.283H257.784V214.127H290.784V206.212Z",
    fill: "#5D87FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.128 256.461H237.807V287.05H229.44V255.937H222.643L234.148 223.777L245.128 256.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.623 183.318V300.451M205.361 183.282L174.727 214.353M201.964 179.529L174.468 207.418M114.55 214.694H174.513V207.556H81.6189M257.569 214.067H225.401V206.929H288.071M205.711 183.107L225.003 213.973M213.176 187.754L225.449 207.068",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.069 233.648H130.578C128.081 233.648 126.057 235.673 126.057 238.169V264.424C126.057 266.921 128.081 268.945 130.578 268.945H187.069C189.566 268.945 191.59 266.921 191.59 264.424V238.169C191.59 235.673 189.566 233.648 187.069 233.648Z",
    fill: "#2E186A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.637 257.178C132.511 257.18 132.387 257.157 132.271 257.109C132.155 257.062 132.05 256.992 131.962 256.903C131.871 256.816 131.801 256.711 131.753 256.595C131.706 256.479 131.684 256.354 131.687 256.228C131.684 256.031 131.743 255.838 131.856 255.677L143.288 239.148C143.374 239.022 143.491 238.921 143.628 238.854C143.765 238.786 143.917 238.756 144.069 238.765C144.194 238.764 144.318 238.787 144.434 238.834C144.55 238.881 144.655 238.951 144.744 239.04C144.832 239.128 144.902 239.234 144.949 239.349C144.996 239.465 145.02 239.59 145.018 239.715V255.279H147.881C148.006 255.279 148.13 255.304 148.245 255.351C148.36 255.399 148.465 255.469 148.553 255.557C148.641 255.645 148.711 255.75 148.759 255.865C148.806 255.98 148.831 256.104 148.831 256.228C148.831 256.353 148.806 256.476 148.759 256.592C148.711 256.707 148.641 256.812 148.553 256.9C148.465 256.988 148.36 257.058 148.245 257.105C148.13 257.153 148.006 257.178 147.881 257.178H145.018V262.32C145.018 262.571 144.918 262.813 144.74 262.991C144.562 263.169 144.321 263.269 144.069 263.269C143.817 263.269 143.575 263.169 143.397 262.991C143.219 262.813 143.119 262.571 143.119 262.32V257.178H132.637ZM143.119 255.279V242.789L134.472 255.279H143.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.278 250.972C151.239 248.843 151.507 246.719 152.074 244.667C152.604 242.893 153.35 241.486 154.31 240.447C154.885 239.911 155.547 239.479 156.269 239.169C157.003 238.863 157.789 238.705 158.584 238.705C159.379 238.705 160.166 238.863 160.899 239.169C161.616 239.482 162.276 239.914 162.849 240.447C163.819 241.49 164.567 242.897 165.091 244.667C166.144 248.81 166.144 253.152 165.091 257.295C164.567 259.072 163.819 260.478 162.849 261.515C162.277 262.05 161.618 262.482 160.899 262.793C160.166 263.101 159.379 263.26 158.584 263.26C157.789 263.26 157.002 263.101 156.269 262.793C155.549 262.487 154.888 262.056 154.316 261.521C153.356 260.48 152.61 259.074 152.08 257.301C151.51 255.241 151.24 253.109 151.278 250.972ZM158.578 240.595C158.033 240.587 157.492 240.692 156.989 240.902C156.486 241.113 156.032 241.425 155.654 241.819C154.011 243.657 153.19 246.708 153.192 250.972C153.194 255.236 154.015 258.302 155.654 260.171C156.033 260.562 156.487 260.871 156.99 261.078C157.494 261.286 158.034 261.387 158.578 261.376C159.122 261.384 159.661 261.281 160.164 261.074C160.666 260.867 161.121 260.559 161.502 260.171C163.157 258.314 163.984 255.248 163.982 250.972C163.98 246.696 163.153 243.645 161.502 241.819C161.122 241.429 160.667 241.12 160.164 240.91C159.662 240.701 159.122 240.596 158.578 240.601V240.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.368 257.178C169.243 257.179 169.119 257.155 169.004 257.108C168.888 257.061 168.783 256.991 168.695 256.902C168.607 256.814 168.537 256.709 168.49 256.593C168.443 256.477 168.42 256.353 168.422 256.228C168.419 256.032 168.477 255.839 168.588 255.677L180.023 239.148C180.108 239.022 180.225 238.92 180.362 238.853C180.499 238.786 180.651 238.756 180.803 238.765C180.928 238.762 181.052 238.785 181.168 238.832C181.284 238.879 181.388 238.95 181.475 239.04C181.565 239.127 181.636 239.233 181.684 239.349C181.731 239.465 181.755 239.589 181.753 239.715V255.279H184.613C184.738 255.277 184.863 255.3 184.979 255.348C185.095 255.396 185.2 255.467 185.288 255.556C185.464 255.736 185.562 255.978 185.562 256.23C185.562 256.482 185.464 256.723 185.288 256.904C185.2 256.992 185.094 257.062 184.978 257.109C184.862 257.157 184.738 257.18 184.613 257.178H181.744V262.32C181.746 262.445 181.722 262.57 181.675 262.686C181.627 262.802 181.556 262.907 181.466 262.995C181.287 263.17 181.045 263.269 180.794 263.269C180.543 263.269 180.302 263.17 180.122 262.995C180.032 262.907 179.961 262.802 179.914 262.686C179.866 262.57 179.843 262.445 179.845 262.32V257.178H169.368ZM179.854 255.279V242.789L171.195 255.279H179.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 302.523H359.096",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_930_15028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatbao404);
export default __webpack_public_path__ + "static/media/matbao-404.544c3bd793c41d77bbe6eccb72cde01a.svg";
export { ForwardRef as ReactComponent };